import $ from "jquery";
import ko from "knockout";
import "flow/bindings/dateBinding";
import dateHelper from "flow/utils/dateHelper";
import register from "flow/knockout/register";

register.registerKnockoutBinding("monthIntervalEnd", {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        ko.bindingHandlers.date.init(
            element,
            function () {
                return valueAccessor().end;
            },
            allBindingsAccessor,
            viewModel,
            bindingContext
        );
        const startDateObservable = valueAccessor().start;
        const endDateObservable = valueAccessor().end;
        const daysAfterStartDate = valueAccessor().daysAfterStartDate;
        const defaultMinDate = new Date(-999999999999999);

        valueAccessor().end = ko.computed(function () {
            const startDate = startDateObservable();
            let minDate = $(element).datepicker("option", "minDate");
            let currDate = endDateObservable();

            if (dateHelper.isValidDateFormat(startDate) && minDate !== dateHelper.addDays(startDate, 1)) {
                minDate = dateHelper.addDays(startDate, daysAfterStartDate);
            } else if (!dateHelper.isValidDateFormat(startDate) && minDate !== defaultMinDate) {
                minDate = defaultMinDate;
            }
            $(element).datepicker("option", "minDate", minDate);

            if (dateHelper.isValidDateFormat(currDate) && dateHelper.toDate(minDate) > dateHelper.toDate(currDate)) {
                currDate = minDate;
            }

            //Handle IE
            currDate = currDate === "Invalid date" ? "" : currDate;

            $(element).val(currDate);
            return endDateObservable();
        });
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        ko.bindingHandlers.date.update(
            element,
            function () {
                return valueAccessor().end;
            },
            allBindingsAccessor,
            viewModel,
            bindingContext
        );
    }
});
